import script from "./CalculateBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculateBox.vue?vue&type=script&setup=true&lang=js"

import "./CalculateBox.vue?vue&type=style&index=0&id=43e677e1&lang=less"

const __exports__ = script;

export default __exports__